<div class="app-footer">
  <div class="w-full grid grid-nogutter">
    <div class="text-black-400 text-center py-6 col-10 col-offset-1 font-light" data-cy="footer-disclaimer-container">
      <p class="p4 my-0">
        CCS Medical requires a valid prescription for "Rx Only" products (e.g., insulin pump device) prior to dispensing
        the item.
      </p>
      <p class="p4 mb-0 mt-1">
        Syringes and needles cannot be purchased without a prescription from a medical practitioner unless state law
        otherwise allows.
      </p>
    </div>
  </div>

  <div class="bg-secondary-royal-blue-700 w-full grid grid-nogutter font-normal" data-cy="footer-content-container">
    <div class="col-10 col-offset-1 hidden md:block" data-cy="desktop-footer-container">
      <div class="flex justify-content-between px-5 py-6">
        <div class="flex flex-column text-white">
          <a href="https://ccsmed.com" target="_blank">
            <img
              class="mb-6"
              src="assets/images/ccs-footer-logo-white.svg"
              height="40"
              width="132.36"
              alt="My CCS Med Logo"
            />
          </a>
        </div>
        <div class="flex flex-column text-white">
          <h2 class="mb-4 mt-0">Portal Assistance</h2>
          <span class="flex align-items-center mb-4">
            <img class="mr-3" src="assets/images/phone-logo-white.svg" height="18" width="20" alt="Phone" />
            <a class="text-white font-light" href="tel:{{ ccsConfig.helpPhone }}">{{ ccsConfig.helpPhone }}</a>
          </span>
          <span class="flex align-items-center">
            <img class="mr-3" src="assets/images/email-logo-white.svg" height="18" width="20" alt="Email" />
            <a class="text-white font-light" href="mailto:{{ ccsConfig.helpEmail }}">{{ ccsConfig.helpEmail }}</a>
          </span>
        </div>
      </div>
      <div class="grey-top-border text-grey-300 w-full flex align-items-center justify-content-between pt-4 px-5">
        <div class="flex">
          <span class="pr-4">
            <img
              src="./assets/images/ccs-glyph-blue.svg"
              height="28px"
              width="auto"
              alt="CCS Icon"
              class="vertical-align-middle"
            />
            <span class="text-xs vertical-align-top mr-1">TM</span>
            and MyCCSMed<span class="text-xs vertical-align-top">TM</span>
            are the property of CCS Medical, Inc. All rights reserved.
          </span>
          <a class="text-grey-200 px-4 border-left-1" href="https://ccsmed.com/privacy-policy/">Privacy Policy</a>
          <a class="text-grey-200 pl-4 border-left-1" href="https://ccsmed.com/terms/">Terms of Service</a>
        </div>
        <div class="flex align-items-center">
          <a class="text-grey-200 mr-3" href="https://www.facebook.com/CCSMedicalSupplies/">
            <img src="assets/images/facebook-logo-white.svg" height="16" width="16" alt="Facebook" />
          </a>
          <a class="text-grey-200 mr-3" href="https://twitter.com/CCSMedical">
            <img class="twitter-logo" src="assets/images/twitter-logo-white.svg" height="16" alt="Twitter" />
          </a>
          <a class="text-grey-200" href="https://www.linkedin.com/company/ccs-medical/">
            <img src="assets/images/linkedin-logo-white.svg" height="16" width="16" alt="Linkedin" />
          </a>
        </div>
      </div>
      <div class="text-grey-300 w-full flex align-items-center py-4 px-5">
        <span class="pr-4">&copy; 2022 CCS Medical. All rights reserved.</span>
      </div>
    </div>
    <div class="col-12 md:hidden py-0 px-4" data-cy="mobile-footer-container">
      <div class="flex flex-column">
        <div class="flex flex-column m-0 py-6 text-white">
          <a href="https://ccsmed.com" target="_blank" class="mobile-link">
            <img
              class="mb-6"
              src="assets/images/ccs-footer-logo-white.svg"
              height="40"
              width="132.36"
              alt="My CCS Med Logo"
            />
          </a>

          <h2 class="mb-4 mt-0">Portal Assistance</h2>
          <span class="flex align-items-center mb-4">
            <img class="mr-3" src="assets/images/phone-logo-white.svg" height="18" width="20" alt="Phone" />
            <a class="text-white font-light" href="tel:{{ ccsConfig.helpPhone }}">{{ ccsConfig.helpPhone }}</a>
          </span>
          <span class="flex align-items-center">
            <img class="mr-3" src="assets/images/email-logo-white.svg" height="18" width="20" alt="Email" />
            <a class="text-white font-light" href="mailto:{{ ccsConfig.helpEmail }}">{{ ccsConfig.helpEmail }}</a>
          </span>
        </div>
        <div class="grey-top-border text-grey-300 w-full flex flex-column align-items-center m-0 py-5">
          <div class="flex mb-5">
            <a class="text-grey-200 mr-3" href="https://www.facebook.com/CCSMedicalSupplies/">
              <img src="assets/images/facebook-logo-white.svg" height="24" alt="Facebook" />
            </a>
            <a class="text-grey-200 mr-3" href="https://twitter.com/CCSMedical">
              <img class="twitter-logo" src="assets/images/twitter-logo-white.svg" height="24" alt="Twitter" />
            </a>
            <a class="text-grey-200" href="https://www.linkedin.com/company/ccs-medical/">
              <img src="assets/images/linkedin-logo-white.svg" height="24" alt="Linkedin" />
            </a>
          </div>
          <span class="pr-4 pb-4 text-center">
            <img
              src="./assets/images/ccs-glyph-blue.svg"
              height="28px"
              width="auto"
              alt="CCS Icon"
              class="vertical-align-middle"
            />
            <span class="text-xs vertical-align-top mr-1">TM</span>
            and MyCCSMed<span class="text-xs vertical-align-top">TM</span>
            are the property of CCS Medical, Inc. All rights reserved.
          </span>
          <span class="mb-4 text-center">&copy; 2022 CCS Medical. All rights reserved.</span>
          <div class="flex">
            <a class="text-grey-200 pr-4" href="https://ccsmed.com/privacy-policy/">Privacy Policy</a>
            <a class="text-grey-200 pl-4 border-left-1" href="https://ccsmed.com/terms/">Terms of Service</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
